import React from 'react';
// import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import RadioButtonUnChecked from '@material-ui/icons/RadioButtonUnchecked';
import BellIcon from '@material-ui/icons/Notifications';
import classNames from 'classnames';
import { useSpring, animated, config } from 'react-spring';

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(1),
    borderRadius: 10,
  },
  rootActive: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.light,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.primary.light,
    },
  },
  content: {
    padding: 5,
    paddingTop: 10,
    width: 80,
    height: 80,
  },
  label: {
    fontSize: 'x-small',
  },
  check: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: 0,
    right: 5,
  },
  bell: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: 0,
    left: 5,
    transform: 'rotate(45deg)',
  },
  justChecked: {
    fontSize: 100,
  },
}));

const AnimatedCheckCircleRoundedIcon = animated(CheckCircleRoundedIcon);

const MenuButton = props => {
  const {
    triggerAnimation = null,
    hasUnread = null,
    hasAlert = null,
    active,
    label,
    children,
    ...rest
  } = props;
  const [animProps, set] = useSpring(() => ({
    opacity: 0,
    fontSize: 100,
  }));
  const animProps2 = useSpring({
    opacity: 1,
    from: { opacity: 0 },
  });
  const classes = useStyles(animProps);

  function handleOnClick() {
    rest.onClick && rest.onClick(rest.id);
  }

  React.useEffect(() => {
    if (triggerAnimation === rest.id)
      set({
        to: async (next, cancel) => {
          await next({ opacity: 1 });
          await next({ fontSize: 24, opacity: 0, config: config.wobbly });
        },
      });
  }, [triggerAnimation]);

  React.useEffect(() => {}, []);

  return (
    <IconButton
      variant={'outlined'}
      color={active ? 'primary' : 'default'}
      className={classNames(classes.root, { [classes.rootActive]: active })}
      aria-label={label}
      {...rest}
      onClick={handleOnClick}
    >
      <div className={classes.content}>
        <div>{children}</div>
        <div>
          <span className={classes.label}>{label}</span>
        </div>
        {triggerAnimation && (
          <div className={classes.check}>
            <AnimatedCheckCircleRoundedIcon style={animProps} />
          </div>
        )}
        {hasUnread && (
          <div className={classes.check}>
            <AnimatedCheckCircleRoundedIcon style={animProps2} fontSize="small" />
          </div>
        )}
        {!hasUnread && hasUnread !== null && (
          <div className={classes.check}>
            <RadioButtonUnChecked fontSize="small" />
          </div>
        )}
        {hasAlert && (
          <div className={classes.bell}>
            <BellIcon fontSize="small" />
          </div>
        )}
      </div>
    </IconButton>
  );
};

export default MenuButton;
